module.exports = "<p>\n  user-application-view works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-application/user-application-view/user-application-view.component.html
// module id = ./src/app/user-application/user-application-view/user-application-view.component.html
// module chunks = main